const locale = {
	pageTitle: '走心机精密加工产品 | 擎亿精密有限公司',
	pageDesc: '擎亿精密 Cincom L20 瑞士型走心机加工产品展示，φ1–20mm 小径精密零件，涵盖轴类、螺丝、套管、连接器，材质包含不锈钢、铝合金、铜、钛合金，可依图面客制。',
	pageKeywords: '走心机加工产品, Cincom L20, 瑞士型车床, 小径精密零件, 轴类零件, 螺丝加工, 套管加工, 连接器加工, 医疗零件, 航太零件, 台湾精密加工',
	title: '精密加工产品',
	subtitle: 'CNC 车铣复合精密零件展示',
	catAll: '全部',
	catShaft: '轴类／销类',
	catScrew: '螺丝／紧固件',
	catBushing: '套管／套筒',
	catConnector: '接头／连接件',
	catPlate: '板类',
	catComplex: '复合加工件',
	catWorm: '蜗杆',
	matSus: '不锈钢',
	matBrass: '黄铜',
	matCopper: '红铜',
	matAlu: '铝合金',
	matTi: '钛合金',
	matPlastic: '工程塑胶',
	dialogTitle: '擎亿精密有限公司',
};

export default locale;
